<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12xXGOJ/tc-custom/9781612008820.jpg?1729185199459" alt="This image is the cover for the book British Fighter Aircraft in World War I, Casemate Illustrated Special"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">British Fighter Aircraft in World War I, Casemate Illustrated Special
      </h1>
      <p class="bookDescription body article font2">
        <b>A vivid pictorial history: “Buy this book right now. It is rare that ISD gives an instant five-star rating to any new volume, but [this] is a rare book.” —<i>Indy Squadron Dispatch</i></b><br/>  <br/> World War I witnessed unprecedented growth and innovation in aircraft design, construction, and—as the war progressed—mass production. Each country generated its own innovations, sometimes in surprising ways—Albatros Fokker, Pfalz, and Junkers in Germany and Nieuport, Spad, Sopwith, and Bristol in France and Britain. This book focuses on the British approach to fighter design, construction, and mass production.<br/>  <br/> Initially the French led the way in Allied fighter development with their Bleriot trainers, then nimble Nieuport Scouts—culminating with the powerful, fast gun platforms as exemplified by the Spads. The Spads had a major drawback however, in that they were difficult and counterintuitive to fix in the field. The British developed fighters in a very different way; Tommy Sopwith had a distinctive approach to fighter design that relied on lightly loaded wings and simple functional box-girder fuselages. His Camel was revolutionary as it combined all the weight well forward, enabling the Camel to turn very quickly—but also making it an unforgiving fighter for the inexperienced.<br/>  <br/> The Royal Aircraft Factory’s SE5a represented another leap forward with its comfortable cockpit, modern instrumentation, and inline engine—clearly influenced by both Spads and German aircraft. Each manufacturer and design team vied for the upper hand and deftly and quickly appropriated good ideas from other companies—be they friend or foe. Developments in tactics and deployment also influenced design—from the early reconnaissance planes, to turn fighters, and finally planes that relied upon formation tactics, speed, and firepower. This book tells their story through extensive photos and accompanying text.<br/>  <br/> “Handy not only as an aircraft model reference, but also as great reading for all history fans.” —<i>DetailScaleView</i><br/>  <br/> “Sidebars add important information at the proper place.” —<i>Air Power History</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark C. Wilkins
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33b123a0